"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var DoneIcon = function DoneIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#333F48' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.99984 1.66675C5.40484 1.66675 1.6665 5.40508 1.6665 10.0001C1.6665 14.5951 5.40484 18.3334 9.99984 18.3334C14.5948 18.3334 18.3332 14.5951 18.3332 10.0001C18.3332 5.40508 14.5948 1.66675 9.99984 1.66675ZM8.334 13.6776L5.82938 11.1784C5.50375 10.8534 5.5031 10.3261 5.82791 10.0003C6.15293 9.6744 6.68068 9.6738 7.00644 9.99899L8.33234 11.3226L12.1548 7.50008C12.4802 7.17469 13.0078 7.17469 13.3332 7.50008C13.6586 7.82547 13.6586 8.35303 13.3332 8.67842L8.334 13.6776Z",
    fill: color
  }));
};
var _default = DoneIcon;
exports.default = _default;